module.exports = __webpack_public_path__ + "img/truckRearRightOutline.8b89e892.svg";